import { VeeqoLogo, ColorVariant, LogoVariant } from '@veeqo/ui';
import { useEffect } from 'react';
import { Wrapper, Separator } from './styling/styled';
import { usePolling } from './utils/usePolling';
import { ContentStyle } from './content';
import { Background, BackgroundVariant } from './component/Background';
import { DefaultCard } from './component/Card/Cards';
import { Footer } from './component/Footer';

export const Landing = ({
  logoVariant,
  colorVariant,
  contentStyle,
  entryType,
  footer,
}: {
  logoVariant?: LogoVariant;
  colorVariant?: ColorVariant;
  contentStyle: ContentStyle;
  entryType: 'landing' | 'lwsc' | 'insc';
  footer?: boolean;
}) => {
  const { error, ready, jobId } = usePolling(entryType);

  useEffect(() => {
    window.vqMetrics.logPageLoad();
  }, []);

  return (
    <Background
      backgroundVariant={contentStyle === ContentStyle.SELLER_CENTRAL ? BackgroundVariant.None : BackgroundVariant.Glow}
    >
      <Wrapper>
        {contentStyle === ContentStyle.VEEQO ? (
          <VeeqoLogo
            variant={logoVariant}
            colorVariant={colorVariant}
            style={{ width: '208px', height: '87px', margin: 'auto' }}
          />
        ) : (
          <div />
        )}
        <DefaultCard error={error} ready={ready} contentStyle={contentStyle} jobId={jobId} />
        <Separator />
        {footer && contentStyle !== ContentStyle.SELLER_CENTRAL && <Footer contentStyle={contentStyle} />}
      </Wrapper>
    </Background>
  );
};
